// TODO: Remove once BE is fixed.
//       Otherwise we need to hardcode these every year and for every single
//       Package for all customers that are active.

/**
 * SELECT ept.TicketTypeID, ept.EventDateID, eet.TicketTypeLabel
 * FROM events_packages ep
 * JOIN events_packages_tickets ept ON ep.PackageID = ept.PackageID
 * JOIN events_events_dates eed ON ept.EventDateID = eed.EventDateID
 * JOIN events_events_tickettypes eet ON ept.TicketTypeID = eet.TicketTypeID
 * WHERE ep.PackageID = 261
 */
const lakefrontMusicFest = ticketTypeId => {
  // Lakefront Music Fest
  if (ticketTypeId === 38544) {
    // EventDateID
    return 27946; // Weekend Package - FRIDAY ticket
  } else if (ticketTypeId === 38600) {
    // EventDateID
    return 27954; // Weekend Package - SATURDAY ticket
  }
  // send warning to Sentry?
  return undefined;
};

// eslint-disable-next-line
const prideBlockParty = ticketTypeId => {
  // Pride Block Party
  if (ticketTypeId === 38258) {
    // GA Weekend Pass Fri
    return 27867; // Friday 2026
  } else if (ticketTypeId === 38263) {
    // GA Weekend Pass - Sat
    return 27868; // Saturday 2026
  } else if (ticketTypeId === 38268) {
    // GA Weekend Pass - Sun
    return 27869; // Sunday 2026
  }
};

// eslint-disable-next-line
const stCroixEventCenter = ticketTypeId => {
  // MURDER MYSTERY DINNER
  if (ticketTypeId === 37588) {
    // 2 Night Package - FRIDAY, "I Should Have Known"
    return 27489;
  } else if (ticketTypeId === 37587) {
    // 2 Night Package - SATURDAY, "It's Your Last Day"
    return 27490;
  }
};

export const getPackage2027DateID = ticketTypeId => {
  // const dateID = stCroixEventCenter(ticketTypeId);
  // if (typeof dateID === "number") return dateID;
  // const prideDateID = prideBlockParty(ticketTypeId);
  // if (typeof prideDateID === "number") return prideDateID;
  return lakefrontMusicFest(ticketTypeId);
};
